var plugin_rtlignore_default = {
  "alignLeft": "si-4a",
  "textWrapNowrap": "_0-egJ",
  "alignRight": "_8fyhm",
  "alignCenter": "_16CGD",
  "sizeFullWidth": "_2Owkn",
  "renderedInTable": "tooQd",
  "sizeOriginal": "_1-9HI",
  "sizeContent": "T0dxO",
  "sizeSmall": "abqz1",
  "sizeSmallCenter": "CiV0P",
  "flex": "BIhFh",
  "atomic": "_42tfF",
  "embed": "AlL24",
  "horizontalScrollbar": "oA0-2",
  "pluginContainerMobile": "HOyWw"
};
export {
  plugin_rtlignore_default as default
};
//# sourceMappingURL=plugin.rtlignore-scss.js.map
